// Wording for concepts that recur across sections, defined once so the
// explanation on a stat matches the one on a plan card.

export const TOKENS_SAVED_TIP =
  "Context condense stripped before your requests reached the model provider. The provider never saw these tokens, so it never billed you for them.";

export const TOKENS_SAVED_CAP_TIP =
  "How much context condense strips for you each week at premium strength, before your provider ever bills it.";

export const LITE_CAP_TIP =
  "Once your weekly pool is spent, Condense Lite keeps compressing automatically at a capped 20% rate. Extra headroom on your plan that never runs out.";

export const ORG_TOKENS_SAVED_CAP_TIP =
  "How much context condense strips each week, for every seat you buy. Once a seat's pool runs out, Condense Lite keeps that member compressing at a capped rate, around 20% of each prompt, until it refills.";
